import React from 'react';
import PropTypes from 'prop-types';
import styles from './Notifications.module.css';
import classnames from 'classnames';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import omit from 'lodash/omit';
import noop from 'lodash/noop';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';
const { Link } = MaterialUiCore;
export function NotificationCard({ notification, isFaded }) {
    const history = useHistory();
    const { text, mod, nId } = notification;
    return (
        <li
            className={classnames(styles['notification'], {
                [styles['notification--faded']]: isFaded,
            })}
            onClick={() => mod.onNotificationClick(notification, history)}
        >
            <span className={classnames('sct-icon', 'icon-Check-Circle-18', styles['notification__tick'])} />
            <div className={styles['notification__content']}>
                <p>{text}</p>
            </div>
        </li>
    );
}
export default function Notifications({ list, onViewAll, onClose, styleConfig = {} }) {
    const notifications = list.map((item) => omit(item, ['timestamp']));
    const unseenItems = notifications.filter((item) => !item.seen);
    const seenItems = notifications.filter((item) => item.seen);
    const recentItemsFaded = unseenItems.length > 0;
    return (
        <>
            <div
                className={classnames(styles['notifications'], {
                    [styles['notifications--with-padding']]: styleConfig.hasPadding,
                    [styles['notifications--in-drawer']]: onClose,
                })}
            >
                <div className={styles['notifications__header']}>
                    <h5>Notifications</h5>
                    {!!onViewAll && (
                        <Link component="button" variant="body2" onClick={onViewAll}>
                            View all
                        </Link>
                    )}
                    {!!onClose && <span className="sct-icon icon-Remove-18" onClick={onClose} />}
                </div>
                {unseenItems.length > 0 && (
                    <ul className={styles['notifications__list']}>
                        {unseenItems.map((notification, idx) => (
                            <NotificationCard notification={notification} key={notification.nId} hasTick={false} />
                        ))}
                    </ul>
                )}
                {seenItems.length > 0 && (
                    <>
                        {unseenItems.length > 0 && (
                            <div
                                className={classnames(
                                    styles['notifications__header'],
                                    styles['notifications__header--with-underline'],
                                )}
                            >
                                <h6>Recent</h6>
                            </div>
                        )}
                        <ul className={styles['notifications__list']}>
                            {seenItems.map((notification, idx) => (
                                <NotificationCard
                                    isFaded={recentItemsFaded}
                                    notification={notification}
                                    key={notification.nId}
                                />
                            ))}
                        </ul>
                    </>
                )}
            </div>
            {!!onClose && (
                <div className={styles['drawer-view-all']}>
                    <Link href="/bulkupload/history">View All</Link>
                </div>
            )}
        </>
    );
}
